import { render, staticRenderFns } from "./pricingNakladnoy.vue?vue&type=template&id=3ae8bbee&scoped=true"
import script from "./pricingNakladnoy.vue?vue&type=script&lang=js"
export * from "./pricingNakladnoy.vue?vue&type=script&lang=js"
import style0 from "./pricingNakladnoy.vue?vue&type=style&index=0&id=3ae8bbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae8bbee",
  null
  
)

export default component.exports